import PropTypes from 'prop-types';

const Switch = props => {
  const { value } = props;
  const defaultFunc = props.default;

  if (props[value]) {
    return props[value]();
  }

  if (defaultFunc) {
    return defaultFunc();
  }

  return null;
};

Switch.propTypes = {
  value: PropTypes.any.isRequired, // eslint-disable-line react/forbid-prop-types
  default: PropTypes.func.isRequired,
};

export default Switch;
